import { addMinutes, formatUserTime, today } from 'owa-datetime';
import { createLowercaseFormatter } from 'owa-duration-formatter/lib/lowercase';
import { format } from 'owa-strings';
import { getOwaCalendarStrings } from 'owa-strings/owa-calendar-strings';

const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_DAY = 24 * 60;

/**
 * Formats a custom reminder time string for the dropdown options
 * @param {number} reminderTimeInMinutes
 * @param {boolean} formatReminderForAllDay
 */
export default function createReminderDisplayString(
    reminderTimeInMinutes: number,
    formatReminderForAllDay: boolean,
    lowercaseFormatter?: (value: number) => string
): string {
    let reminderText;

    if (!lowercaseFormatter) {
        lowercaseFormatter = createLowercaseFormatter();
    }

    if (reminderTimeInMinutes == -1) {
        reminderText = getOwaCalendarStrings().noReminder;
    } else if (reminderTimeInMinutes == 0) {
        reminderText = getOwaCalendarStrings().atTimeOfEvent;
    } else if (formatReminderForAllDay && Math.abs(reminderTimeInMinutes) < MINUTES_IN_DAY) {
        // for all day events with reminders within the day, we use strings with format
        // Day of event at <time> or
        // Day before event at <time>
        let nowMidnight = today();
        let timeToUse = addMinutes(nowMidnight, -1 * reminderTimeInMinutes);
        reminderText = format(
            reminderTimeInMinutes < 0
                ? getOwaCalendarStrings().reminderDayOfEvent
                : getOwaCalendarStrings().reminderDayBeforeEvent,
            formatUserTime(timeToUse)
        );
    } else if (
        formatReminderForAllDay &&
        reminderTimeInMinutes < 7 * MINUTES_IN_DAY &&
        reminderTimeInMinutes > 6 * MINUTES_IN_DAY
    ) {
        // for all day events with reminders a week before, we use string with format
        // Week before event at <time>
        let nowMidnight = today();
        let timeToUse = addMinutes(nowMidnight, -1 * reminderTimeInMinutes);
        reminderText = format(
            getOwaCalendarStrings().reminderWeekBeforeEvent,
            formatUserTime(timeToUse)
        );
    } else {
        reminderText = format(
            reminderTimeInMinutes < 0
                ? getOwaCalendarStrings().reminderAfter
                : getOwaCalendarStrings().reminderBefore,
            lowercaseFormatter(Math.abs(reminderTimeInMinutes) * SECONDS_IN_MINUTE)
        );
    }

    return reminderText;
}
